import { registerWidget, IWidgetDefinition } from '../../common/core';
import { IFuseFooterSettings } from './fuse-footer.settings'

var template = require("./fuse-footer.html");

export const FuseFooterWidgetDefinition: IWidgetDefinition<any, IFuseFooterSettings, any> = {
  init(widget) {
    widget.data = {};
  },
  template: template,
  styles: '',
};

registerWidget('fuse-footer', FuseFooterWidgetDefinition);